import React from "react";
import { Box, Button, Modal, Paper, Stack, TextField } from "@mui/material";
import styled from "styled-components";
import { ToastContext } from "src/components/providers/toast-provider";
import request from "src/utils/request";

const ModalContainer = styled(Paper)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const Title = styled.h1`
    font-size: 18px;
    font-weight: 500;
    padding: 0;
    margin: 0;
`;

const SubTitle = styled.h2`
    font-size: 12px;
    font-weight: 300;
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.palette.secondary.main};
    max-width: 28rem;
`;

const SaveGroupModal = ({ selectedRepos, open, handleClose, isDemo, getRepos }) => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const [groupName, setGroupName] = React.useState(undefined);
    const closeModal = () => {
        handleClose();
    };

    const saveGroup = async () => {
        await request(`api/data/repo-groups`, {
            method: "PUT",
            body: JSON.stringify({
                groups: [
                    {
                        name: groupName,
                        repos: selectedRepos,
                    },
                ],
            }),
        });
        setMessage(`Group saved successfully`);
        setSeverity("success");
        setIsToastTriggered(true);
        getRepos();
        handleClose();
    };

    const handleSubmitGroup = async () => {
        try {
            saveGroup();
        } catch {
            setMessage(`Something went wrong. Please try again`);
            setSeverity("warning");
            setIsToastTriggered(true);
        }
    };

    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="save-repo-group-modal"
            aria-describedby="save-repo-group-modal-description"
        >
            <ModalContainer>
                <Box p={3}>
                    <Stack spacing={2} alignItems="flex-start">
                        <Title>Save repo group</Title>
                        <SubTitle>
                            Enter a name and save repositories group. Groups are accessible through
                            the repository select dropdown.
                        </SubTitle>
                        <TextField
                            id="outlined-basic"
                            label="Enter group name*"
                            variant="outlined"
                            size="small"
                            onChange={(event) => {
                                setGroupName(event.target.value);
                            }}
                            InputProps={{
                                sx: {
                                    fontSize: "12px",
                                    fontWeight: 300,
                                    padding: "3.5px",
                                },
                            }}
                            InputLabelProps={{
                                sx: {
                                    fontSize: "12px",
                                    fontWeight: 300,
                                    padding: "3.5px",
                                    "&.MuiOutlinedInput-notchedOutline": {
                                        fontSize: "13px",
                                    },
                                },
                            }}
                        />
                        <Stack direction="row" spacing={2}>
                            <Button color="secondary" size="medium" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                size="medium"
                                disabled={!groupName}
                                type="submit"
                                onClick={isDemo ? handleClose : handleSubmitGroup}
                            >
                                Save Group
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </ModalContainer>
        </Modal>
    );
};

export default SaveGroupModal;
